import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router';

import { MEDIA } from '../constants/media';

// Import constants
import { APP_STORE_URL, PLAY_STORE_URL } from '../constants/links';

// Import components
import SeoHead from '../components/seo/SeoHead';
import CircleLoading from '../components/loading/CircleLoading';

// Import utils
import { detectDevice } from '../utils/device';

export default function GetAppPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const device = detectDevice();

    if (device === 'ios') {
      // Redirect to App Store
      window.location.href = APP_STORE_URL;
    } else if (device === 'android') {
      // Redirect to Google Play Store
      window.location.href = PLAY_STORE_URL;
    } else {
      // If device can't be detected, redirect to app page
      navigate('/app', { replace: true });
    }
  }, [navigate]);

  // Show a loading state while redirecting
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 flex items-center justify-center">
      <SeoHead route="/get-app" />
      <div className="flex flex-col gap-4 items-center text-center">
        <Link to="/">
          <img
            src={MEDIA.logo}
            alt="WhenWeMeet"
            className="h-32 w-32 rounded-4xl shadow shadow-gray-300 object-cover"
            loading="lazy"
            decoding="async"
          />
        </Link>
        <p className="text-base text-gray-800">Redirecting to get the app...</p>
        <CircleLoading />
      </div>
    </div>
  );
}
